<template>
    <v-dialog v-model="openDialogPrediction" persistent :overlay="false" max-width="1366px"
        transition="dialog-transition">
        <v-card>
            <v-toolbar dark color="primary" dense>
                <v-spacer></v-spacer>
                <v-toolbar-title>
                    Consumption Forecast
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="$emit('close')"><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>
            <v-container grid-list- fluid>
                <v-row>
                    <v-col cols="2">
                        <v-combobox :items="stations" :item-text="'Station'" :item-value="'id'" label="Station" dense
                            class="mx-3 mt-3" v-model="station"></v-combobox>
                    </v-col>
                    <!-- <v-col cols="2">
                        <v-combobox :items="products" :item-text="'Product'" :item-value="'ProductID'" label="Product"
                            dense class="mx-3 mt-3" v-model="product"></v-combobox>
                    </v-col> -->
                    <v-col cols="2">
                        <v-text-field label="Date Prediction" id="PredictionDate" class="mt-3" v-model="DatePrediction" dense
                            placeholder="YYYY-MM-DD" v-mask="'####-##-## ##:##'" :rules="$store.state.dateRules" required></v-text-field>
                    </v-col>
                    <v-btn color="secondary" class="mt-4" @click="getPrediction">Prediction</v-btn>
                </v-row>
                <v-row>
                    <v-container grid-list-xs>
                        <v-data-table
                            :headers="headers"
                            :items="pronostic"
                            dense
                        >
                        <template v-slot:item.Total="{ item }">
                            <td>{{ item.Total }} L</td>
                        </template>
                        </v-data-table>
                    </v-container>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios';
import { mask } from 'vue-the-mask';
import moment from 'moment';
export default {
    props: ['openDialogPrediction'],
    directives: { mask },
    data: function () {
        return {
            stations: [],
            station: null,
            product: null,
            products: [],
            DatePrediction:null,
            pronostic:[],
            headers: [
                { text: 'Product', value: 'ProductName', align:'center'},
                { text: 'Total Consumption', value: 'Total',align:'center'},
            ]
        }
    },
    methods: {
        loadStations: function () {
            axios
                .get('readings/station/with/consuption')
                .then(response => {
                    console.log(response.data);
                    this.stations = response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        loadProducts: function () {
            this.$store.state.isLoading = true;
            axios
                .get('product/active')
                .then(response => {
                    this.products = response.data.data;
                    this.$store.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    this.$store.state.isLoading = false;
                });
        },
        getPrediction: function (){
            var str = this.$store;
            str.state.isLoading = true;
            var parms = {
                // Station: this.station.id,
                Station: this.station.id,
                // Product: this.product.ProductID,
                DatePredictionTime: this.DatePrediction,
                DatePrediction: moment(this.DatePrediction).format('YYYY-MM-DD'),
                PresentDateTime : moment().format('YYYY-MM-DD HH:mm'),
                PresentDate:  moment().format('YYYY-MM-DD')
            }
            axios
                .post('readings/prediction/consuption', parms, )
                .then(response => {
                    console.log(response.data)
                    this.pronostic = response.data;
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        }
    },
    mounted() {
        this.loadStations();
        this.loadProducts();
    },

}
</script>